import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";
import { UrgentSourcingAnalyticsFilters } from "../UrgentSourcingDashboard/UrgentSourcingAnalyticsFilters";

export interface StockCheckAnalyticsFilters {
  order_id: FilterValue[] | null;
  raised_by: FilterValue[] | null;
  closed_by: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
}

export interface StockCheckAnalyticsSelectedFilters {
  order_id: FilterValue[] | null;
  raised_by: FilterValue[] | null;
  closed_by: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export interface StockCheckAnalyticsAPIFilters {
  order_id: FilterValue[] | null;
  raised_by: FilterValue[] | null;
  closed_by: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export function parseQueryParamsForStockCheckAnalyticsFilters(
  params: StockCheckAnalyticsFilters | null,
  query_params: URLSearchParams
): StockCheckAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    order_id: params?.order_id ?? [],
    raised_by: params?.raised_by ?? [],
    closed_by: params?.closed_by ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
  };
}
